import { useRepositoryQuery } from '@mews-commander/data-access';
import { useLanguageCode } from '@mews-commander/core';

export const useCustomerQuery = (customerId: string, enabled: boolean) => {
    const languageCode = useLanguageCode();

    return useRepositoryQuery(
        'accounts',
        'getAll',
        {
            languageCode,
            accountIds: [customerId],
        },
        {
            enabled: !!customerId && enabled,
            select: (data) => data?.customers?.find((customer) => customer.id === customerId),
        }
    );
};
